import React from 'react';
import { NavLink } from 'react-router-dom';
import { NAVIGATION } from '../app/navigation.js';

export function Sidebar({ mobileOpen, onClose }) {
  return (
    <>
      <aside className={`sidebar ${mobileOpen ? 'is-open' : ''}`} aria-label="Navigazione principale">
        <div className="sidebar-brand">
          <img src="/branding/myworld-logo.svg" alt="MyWorld" />
        </div>
        <nav className="sidebar-nav">
          {NAVIGATION.map((group) => (
            <section className="nav-group" key={group.label}>
              <div className="nav-group-label">{group.label}</div>
              {group.items.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  onClick={onClose}
                  className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
                >
                  <span className="nav-icon" aria-hidden="true">{item.icon}</span>
                  <span>{item.label}</span>
                </NavLink>
              ))}
            </section>
          ))}
        </nav>
      </aside>
      {mobileOpen && <button className="sidebar-backdrop" onClick={onClose} aria-label="Chiudi menu" />}
    </>
  );
}
